import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcVacation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.551 9.183a.42.42 0 0 0-.328-.158l-.075.007a.42.42 0 0 0-.304.595l1.346 2.79H9.86l-.111-.05-.759-.83a.196.196 0 0 0-.34.131v2.873c0 .107.088.194.196.194h.04a.2.2 0 0 0 .143-.061l.748-.793.109-.047h2.301l-1.344 2.79a.42.42 0 0 0 .708.443l2.535-3.177.117-.056h1.308c.434 0 .84-.335.84-.71 0-.373-.406-.708-.84-.708h-1.294l-.117-.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5 2.625a.75.75 0 0 0-1.5 0V4H5.75A2.75 2.75 0 0 0 3 6.75v12.5A2.75 2.75 0 0 0 5.75 22h12.5A2.75 2.75 0 0 0 21 19.25V6.75A2.75 2.75 0 0 0 18.25 4H17V2.625a.75.75 0 0 0-1.5 0V4h-7zM5.75 5.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25z",
    clipRule: "evenodd"
  }));
}
var IcVacation = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVacation));

export { IcVacation as I };
